<div class="py-2" *ngIf="!isLoadingDiagnosis">
  <div class="row">
    <div class="col-md-auto col-12">
      <div class="h-100 d-flex align-items-center ">
      <h3 class="page-subtitle">{{ category }}s</h3>
      <button
        type="button"
        class="btn btn-primary btn-sm ml-3"
        data-toggle="modal"
        data-target="#addDiagnosisModal"
      >
      <i class="fa fa-plus"></i>  Add Item
      </button>
      </div>
    </div>
    <div class="col">

    </div>
    <div class="col-md-3">
      <div class="searchbox">
        <input
          class="search-diagnosis form-control"
          type="text"
          name="searchDiagnosis"
          placeholder="Search {{ category }}"
          (keyup)="filterDiagnosis($event)"

        />
        <span class="fa fa-search"></span>
      </div>
    </div>
  </div>
</div>
<div class="spinner d-block w-100 py-5 text-center" *ngIf="isLoadingDiagnosis">
  <span class="spinner-border spinner-border-md mx-auto" role="status"></span>
</div>
<div *ngIf="!isLoadingDiagnosis">
  <div *ngIf="category==='Disease'">
    <table class="table table-primary table-bordered tab-dat">
      <thead class="thead-light-">
        <tr class="text-uppercase">
          <th>#</th>
          <th scope="col">Disease Name</th>
          <th scope="col">Image</th>
          <th scope="col">Status</th>
          <th scope="col">Cause</th>
          <th scope="col">Description</th>
          <th scope="col">Prevention & Control</th>
          <th scope="col">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="diseaseDataFilter?.length===0" style="text-align: center;">
          <td colspan="8">No disease added yet...</td>
        </tr>
        <tr *ngFor="let row of diseaseDataFilter | paginate: { id: 'pag1', itemsPerPage: count , currentPage: dPage };
          let i = index"
        >
          <td>{{ (dPage - 1) * count + i + 1 }}</td>
          <td><b class="text-primary">{{ row.name }}</b></td>
          <td>
            <div class="mult_images">
              <div *ngFor="let photo of row.media">
                <div class="img-holder" *ngIf="photo.photo_url">
                  <img src='{{ "https://storage.googleapis.com/ezyagric-media" + photo.photo_url }}' 
                  alt="disease image"
                />
                </div>
              </div>
            </div>
          </td>
          <td 
            [className]="row.status"
          >
            <span class="dot mr-2"></span>
            {{row.status | titlecase}}
          </td>
          <td>{{ row.cause }}</td>
          <td [innerHTML]="row.explanation | truncateText:10" class="text"> </td>
          <td [innerHTML]="row.control | truncateText:10" class="text"></td>
          <td>
            <div class="dropdown">
              <button class="btn btn-outline-info dropdown-toggle" type="button" id="dropdownMenuButton"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                ACTION
              </button>
              <div class="dropdown-menu dropdown-menu-right options" aria-labelledby="dropdownMenuButton">
                <button
                  class="dropdown-item suspend"
                  (click)="setSingleDiagnosisView(row)"
                  data-toggle="modal"
                  data-target="#editDiagnosisModal"
                >
                  View details
                </button>
                <button
                  *ngIf="checkPublishStatus('inactive', row)"
                  class="dropdown-item suspend text-success"
                  data-toggle="modal"
                  data-target="#publishModal"
                  (click)="setSingleDiagnosisView(row)"
                >
                  Publish
                </button>
                <button
                  *ngIf="checkPublishStatus('active', row)"
                  class="dropdown-item suspend text-danger"
                  data-toggle="modal"
                  data-target="#publishModal"
                  (click)="setSingleDiagnosisView(row)"
                >
                  Unpublish
                </button>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  
    <nav>
      <pagination-controls id="pag1" (pageChange)="dPage = $event"></pagination-controls>
    </nav>
  </div>

  <div *ngIf="category==='Pest'">
    <table class="table table-primary table-bordered tab-dat">
      <thead class="thead-light-">
        <tr class="text-uppercase">
          <th>#</th>
          <th scope="col">Pest Name</th>
          <th scope="col">Image</th>
          <th scope="col">Status</th>
          <th scope="col">Description</th>
          <th scope="col">Prevention & Control</th>
          <th scope="col">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="pestDataFilter?.length===0" style="text-align: center;">
          <td colspan="7">No pest added yet...</td>
        </tr>
        <tr *ngFor="let row of pestDataFilter | paginate: { id: 'pag2', itemsPerPage: count , currentPage: pPage };
          let i = index"
        >
          <td>{{ (pPage - 1) * count + i + 1 }}</td>
          <td><b class="text-primary">{{ row.name }}</b></td>
          <td>
            <div class="mult_images">
              <div *ngFor="let photo of row.media">
                <div class="img-holder" *ngIf="photo.photo_url">
                  <img src='{{ "https://storage.googleapis.com/ezyagric-media" + photo.photo_url }}' 
                  alt="pest image"
                />
                </div>
              </div>
            </div>
          </td>
          <td 
            [className]="row.status"
          >
            <span class="dot mr-2"></span>
            {{row.status | titlecase}}
          </td>
          <td [innerHTML]="row.explanation | truncateText:10" class="text"> </td>
          <td [innerHTML]="row.control | truncateText:10" class="text"></td>
          <td>
            <div class="dropdown">
              <button class="btn btn-outline-info dropdown-toggle" type="button" id="dropdownMenuButton"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                ACTION
              </button>
              <div class="dropdown-menu dropdown-menu-right options" aria-labelledby="dropdownMenuButton">
                <button
                  class="dropdown-item suspend"
                  (click)="setSingleDiagnosisView(row)"
                  data-toggle="modal"
                  data-target="#editDiagnosisModal"
                >
                  View details
                </button>
                <button
                  *ngIf="checkPublishStatus('inactive', row)"
                  class="dropdown-item suspend text-success"
                  data-toggle="modal"
                  data-target="#publishModal"
                  (click)="setSingleDiagnosisView(row)"
                >
                  Publish
                </button>
                <button
                  *ngIf="checkPublishStatus('active', row)"
                  class="dropdown-item suspend text-danger"
                  data-toggle="modal"
                  data-target="#publishModal"
                  (click)="setSingleDiagnosisView(row)"
                >
                  Unpublish
                </button>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  
    <nav>
      <pagination-controls id="pag2" (pageChange)="pPage = $event"></pagination-controls>
    </nav>
  </div>
</div>
